export const loginUrl = "/login";

export const budgetModuleUrl = "/budget/:clientId/:connectionId";
export const liquidityModuleUrl = "/liquidity/:clientId/:connectionId";
export const profitAndLossModuleUrl = "/profit-and-loss/:clientId/:connectionId";
export const balanceSheetModuleUrl = "/balance/:clientId/:connectionId";
export const dataMappingModuleUrl = "/data-mapping/:clientId/:submodule?";

export const notFoundUrl = "/not-found";